import { useCallback, useState } from 'react'

import { isNull, isUndefined } from 'lodash'

import { getTranslate } from 'react-localize-redux'
import QuestionCard from './QuestionCard'
import IconButton from '../../../antd/Buttons/IconButton'
import { faCheck } from '@fortawesome/pro-solid-svg-icons'
import { connect } from 'react-redux'

const mapStateToProps = state => ({ t: getTranslate(state.locale) })

const EvaluationPanel = ({ comment = '', questions = [], loading, name, submitted, t, onSubmit }) => {
  const initialQuestions = questions.map(q => ({ id: q.id, answer: q.answer ?? null, label: q.label }))

  const [currentQuestions, setCurrentQuestions] = useState(initialQuestions)
  const [currentComment, setCurrentComment] = useState(comment)

  const handleAnswerSelected = useCallback((questionId, answer) => {
    setCurrentQuestions(currentQuestions.map(q => q.id === questionId ? { ...q, answer } : q))
  }, [currentQuestions])

  const evaluateDirtiness = () => {
    const areQuestionDirty = currentQuestions.reduce((acc, question) => {
      const originalQuestion = initialQuestions.find(item => item.id === question.id)

      if (isUndefined(originalQuestion) || question.answer !== originalQuestion.answer) {
        acc = true
      }

      return acc
    }, false)

    return areQuestionDirty || comment !== currentComment
  }

  const isValid = currentQuestions.every(item => item.answer !== null)
  const isDirty = evaluateDirtiness()
  const isNew = initialQuestions.every(item => isNull(item.answer))

  return (
    <div className='recruitment-module-wrapper'>
      <div className='info-text'>{t('How was your internship experience with')} {name} {t('within your unit?')}</div>
      <label>{t('Questions')}</label>
      <div className='questions-list'>
        {currentQuestions.map(q => (<QuestionCard key={q.id} question={q} onAnswerSelected={handleAnswerSelected} />))}
      </div>
      <div className='comments-wrapper'>
        <label>{t('common.comments')}</label>
        <textarea
          value={currentComment}
          onChange={e => setCurrentComment(e.target.value)}
          placeholder={t("Comments about student's internship")}
        />
      </div>
      <div className='submit-feedback-wrapper'>
        {submitted && !(isDirty || isNew) && <span className='previously-evaluated'>{t('Your feedback was recorded, thank you!')} </span>}
        {(isDirty || isNew) && (
          <IconButton
            disabled={!isDirty || !isValid}
            text={t(isNew ? 'common.confirm' : 'common.update')}
            type='primary'
            icon={faCheck}
            loading={loading}
            onClick={() => onSubmit(currentQuestions, currentComment)}
          />
        )}
      </div>
    </div>
  )
}

export default connect(mapStateToProps)(EvaluationPanel)
